// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton-module--base--R_wry","active":"skeleton-module--active--s0cga","skeleton":"skeleton-module--skeleton--3Vcat"};